import * as React from 'react';
import { createRoot } from 'react-dom/client';

import Plans from '@/pages/Plans';
import { renderWithUiRoot, resolveReactMountContainer } from '@/js/wisemetering/ui/render_with_ui_root';

WiseMetering.Views.NoAccess = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    initialize: function() {
        this.listenTo(WiseMetering.currentOrganization, 'change', this.onModelChange.bind(this));
    },

    onShow: function() {
        const container = resolveReactMountContainer(this);
        if (!container) {
            console.error(`Element with id "${this.id}" not found.`);
            return;
        }
        this.reactContainer = container;
        this.reactRoot = createRoot(container);
        this.renderReactComponent();
    },

    onModelChange: function() {
        this.renderReactComponent();
    },

    renderReactComponent: function() {
        if (this.reactRoot) {
            renderWithUiRoot(
                this.reactRoot,
                this.reactContainer,
                <Plans organization={WiseMetering.currentOrganization.toJSON()} currentPlan={WiseMetering.currentOrganization.plan().toJSON()} noAccess={true}/>
            );
        }
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount();
            this.reactRoot = null;
            this.reactContainer = null;
        }
        this.stopListening(WiseMetering.currentOrganization);
    }
});
